import { Flex } from '@revenuemarket/cds';
import { Breadcrumb } from 'antd';
import { FlattenTreeResult } from '~components/ui/HorizontalTreeTable/Table';
import { css } from '~libs/emotion';

const Header = <T extends Record<string, unknown>>({
  namePath,
  keyPath,
  viewStatus,
  onBreadcrumbClick,
}: T & {
  namePath: string;
  keyPath: string;
  viewStatus: 'new' | 'info';

  onBreadcrumbClick?: (key: string) => void;
}) => {
  const breadcrumbItems =
    viewStatus === 'info'
      ? namePath.split('.').map((key, index) => {
          return {
            key: keyPath.split('.')[index],
            onClick: () => {
              onBreadcrumbClick?.(keyPath.split('.')[index]);
            },
            title: key,
            className: css`
              cursor: pointer;
            `,
          };
        })
      : [
          ...namePath?.split('.').map((key, index) => {
            return {
              key: keyPath.split('.')[index],
              onClick: () => {
                onBreadcrumbClick?.(keyPath.split('.')[index]);
              },
              title: key,
              className: css`
                cursor: pointer;
              `,
            };
          }),
          {
            key: 'new',
            title: '생성중..',
          },
        ];

  return (
    <Flex direction="column" gap={8}>
      <Breadcrumb items={breadcrumbItems} />
    </Flex>
  );
};

interface Props<T extends Record<string, unknown>> {
  activeItem: FlattenTreeResult<T>;
  flattenedTree: FlattenTreeResult<T>[];
  setActiveItem: (item?: FlattenTreeResult<T>) => void;
  namePath: string;
  keyPath: string;
  viewStatus: 'new' | 'info';
}

const PanelHeader = <T extends Record<string, unknown>>({
  activeItem,

  flattenedTree,
  setActiveItem,
  namePath,
  keyPath,
  viewStatus,
}: Props<T>) => {
  return (
    <Header
      {...activeItem.value}
      namePath={namePath}
      keyPath={keyPath}
      viewStatus={viewStatus}
      onBreadcrumbClick={(key) => {
        const result = flattenedTree.find((i) => i.key === key) as FlattenTreeResult<T>;
        setActiveItem(result);
      }}
    />
  );
};

export default PanelHeader;
